<template>
    <validation-observer ref="refForm">

        <b-form
            @submit.prevent="onSubmit"
            @reset.prevent="resetForm"
        >

            <b-row>
                <b-col md="12">
                    <b-card footer-tag="footer">

                        <b-row>

                            <!-- NOTICE TYPE -->
                            <b-col
                                cols="12"
                            >
                                <b-form-group
                                    label-for="notice_type"
                                >
                                    <template #label>
                                        <strong>TIPO DE ANUNCIO</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="tipo de anuncio"
                                    >
                                        <v-select
                                            id="notice_type"
                                            placeholder="Seleccionar una opción"
                                            v-model="formData.notice_type"
                                            :options="options.noticeTypes"
                                            @input="onNoticeTypeChange"
                                            :state="errors.length > 0 ? false : null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- NOTICE TYPE: IMAGE -->
                            <template v-if="formData.notice_type && formData.notice_type.value === 1">

                                <b-col cols="12">
                                    <b-alert variant="info" :show="true">
                                        <div class="alert-body">
                                            <ul class="mb-0">
                                                <li>
                                                    Comprime y optimiza tus imágenes en 
                                                    <b-link
                                                        class="alert-link"
                                                        href="https://tinypng.com/"
                                                        target="_blank"
                                                    >
                                                        Tinify
                                                    </b-link>
                                                </li>
                                                <li>
                                                    Convierte tus imágenes a .webp en 
                                                    <b-link
                                                        class="alert-link"
                                                        href="https://pixelied.com/convert/jpg-converter"
                                                        target="_blank"
                                                    >
                                                        Pixelied
                                                    </b-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </b-alert>
                                </b-col>

                                <!-- IMAGE -->
                                <b-col md="12">

                                    <!-- PREVIEW IMG -->
                                    <div id="preview" v-if="formData.imageUrl">
                                        <b-img
                                            fluid
                                            :src="formData.imageUrl"
                                            thumbnail
                                            width="300"
                                            alt="image"
                                        />
                                    </div>

                                    <!-- IMG -->
                                    <b-form-group
                                        label-for="image"
                                    >
                                        <template #label>
                                            <strong>IMAGEN (FORMATO: webp)</strong>
                                        </template>
                                        <b-form-file
                                            id="image"
                                            v-model="formData.image"
                                            @change="onFileChange"
                                            accept=".webp"
                                            ref="image"
                                            placeholder="Elija una imagen ..."
                                            no-drop
                                        />
                                    </b-form-group>
                                    <b-button variant="outline-primary" class="mb-2" @click="restoreImage" v-if="formData.image">Restaurar imagen</b-button>
                                </b-col>

                            </template>

                            <!-- NOTICE TYPE: VIDEO -->
                            <template v-if="formData.notice_type && formData.notice_type.value === 2">

                                <!-- YOUTUBE ID -->
                                <b-col cols="12" md="6">
                                    <b-form-group
                                        label-for="youtube_id"
                                        class="mb-0"
                                    >
                                        <template #label>
                                            <strong>CÓDIGO DE YOUTUBE (https://www.youtube.com/watch?v=<span class="text-primary">bo9Z_pgByQY</span>)</strong>
                                        </template>
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            name="código de youtube"
                                        >
                                            <b-form-input
                                                id="youtube_id"
                                                v-model="formData.youtube_id"
                                                placeholder="Ingrese el código de youtube ..."
                                                :state="errors.length > 0 ? false : null"
                                                trim
                                            />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>

                            </template>

                            <!-- DISPLAY ORDER -->
                            <b-col cols="12" md="4">
                                <b-form-group label-for="displayOrder">
                                    <template #label>
                                        <strong>ORDEN EN LA WEB</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="integer"
                                        name="orden"
                                    >
                                        <b-form-input
                                            id="displayOrder"
                                            v-model="formData.displayOrder"
                                            type="number"
                                            min="0"
                                            placeholder="Vacío = al final ..."
                                            :state="errors.length > 0 ? false : null"
                                            trim
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <small class="text-muted">Define la posición en la que aparece en el pop-up de la web. El menor número va primero. Si el número ya está en uso, los demás se recorren automáticamente. Si lo dejas vacío, se muestra al final, empezando por el más reciente.</small>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <template #footer>

                            <!-- BUTTON SUBMIT -->
                            <b-button-loading 
                                text="ACTUALIZAR" 
                                type="submit"
                                :processing="processing">
                            </b-button-loading>

                            <b-button
                                variant="outline-secondary"
                                class="ml-1"
                                :to="{ name: 'notices' }"
                            >
                                CANCELAR
                            </b-button>

                        </template>

                    </b-card>
                </b-col>
            </b-row>

        </b-form>

    </validation-observer>
</template>

<script>

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import BButtonLoading from '@core/components/b-button-loading/BButtonLoading.vue';
    import { ref, onBeforeMount, onUnmounted } from '@vue/composition-api';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { useToast } from 'vue-toastification/composition';
    import noticeStoreModule from '../noticeStoreModule';
    import Ripple from 'vue-ripple-directive';
    import { required } from '@validations';
    import vSelect from 'vue-select';
    import store from '@/store';
    import axios from '@axios';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

            BButtonLoading,

            required,

            vSelect
        },
        directives: {
            Ripple
        },
        props: {
            noticeData: {
                type: Object,
                required: true
            }
        },
        setup(props) {

            // USE TOAST
            const toast = useToast();

            // REFS
            const noticeData = ref(props.noticeData);
            
            const processing = ref(false);
            const refForm = ref(null);
            const options = ref({});
            
            const image = ref(null);

            const formData = ref({
                id: null,
                notice_type: null,
                imageUrl: null,
                image: null,
                youtube_id: null,
                displayOrder: null
            });

            const NOTICE_APP_STORE_MODULE_NAME = 'app-notice';

			// REGISTER MODULE
			if (!store.hasModule(NOTICE_APP_STORE_MODULE_NAME)) store.registerModule(NOTICE_APP_STORE_MODULE_NAME, noticeStoreModule);

			// UNREGISTER ON LEAVE
			onUnmounted(() => {
				if (store.hasModule(NOTICE_APP_STORE_MODULE_NAME)) store.unregisterModule(NOTICE_APP_STORE_MODULE_NAME);
			});

            // CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
            onBeforeMount( async () => {
                await getSelectFilters();
                setData();
            });

            const getSelectFilters = async () => {
                const response = await axios.get('/notice-types/select');
                options.value = response.data;
            };

            const setData = () => {

                const noticeType = options.value.noticeTypes.find(item => item.value === noticeData.value.notice_type_id);
                
                formData.value = {
                    ...noticeData.value,
                    notice_type: noticeType,
                    youtube_id: noticeData.value.youtube_code,
                    displayOrder: noticeData.value.display_order,
                    image: null
                }

            };

            const getNoticeData = async () => {

                store.dispatch('app-notice/fetchNotice', { id: formData.value.id })
                    .then(response => {
                        noticeData.value = response.data;
                        setData();
                    });

            };

            const onFileChange = (e) => {
                const file = e.target.files[0];

                if (file) {
                    formData.value.image = file;
                    formData.value.imageUrl = URL.createObjectURL(file);
                } else {
                    formData.value.image = null;
                    formData.value.imageUrl = null;
                }
            };

            const onNoticeTypeChange = (e) => {
                if (!e) {

                    formData.value.notice_type = null;

                    formData.value.imageUrl = null;
                    formData.value.image = null;
                    formData.value.youtube_id = null;

                } else {

                    if (e.value === 1) { // IMAGE
                        formData.value.youtube_id = null;
                    } else { // VIDEO
                        formData.value.imageUrl = null;
                        formData.value.image = null;
                    }

                }
            };

            const restoreImage = () => {
                formData.value.imageUrl = noticeData.value.imageUrl;
                formData.value.image = null;

                image.value.reset();
            };

            const onSubmit = async () => {

                const isValid = await refForm.value.validate();

                if (!isValid)
                {
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Complete los campos requeridos.',
                            icon: 'AlertTriangleIcon',
                            variant: 'warning'
                        }
                    });
                    
                    return;
                }

                processing.value = true;

                const {

                    id,
                    notice_type,
                    image,
                    youtube_id,
                    displayOrder

                } = formData.value;

                const payload = {
                    notice_type: notice_type.value,
                    youtube_id,
                    image,
                    displayOrder
                }

                store.dispatch('app-notice/updateNotice', { id, payload })
                    .then( response => {

                        toast({
                            component: ToastificationContent,
                            props: {
                                title: response.data.message,
                                icon: 'CheckIcon',
                                variant: 'success'
                            }
                        });

                        formData.value.image = null;

                        getNoticeData();

                    })
                    .catch( (err) => {
                        const message = err.response.data.message ? err.response.data.message : 'Error al actualizar la información general del anuncio.';
                        
                        toast({
                            component: ToastificationContent,
                            props: {
                                title: message,
                                icon: 'AlertTriangleIcon',
                                variant: 'danger'
                            }
                        });
                    })
                    .finally( () =>  processing.value = false);

            };

            return {
                // DATA
                processing,
                formData,

                // REFS
                refForm,
                options,
                image,

                // METHODS
                onNoticeTypeChange,
                onFileChange,
                restoreImage,
                onSubmit
            }
        }
    }

</script>

<style lang="scss" scoped>

    #preview {
        text-align: center;
        margin-bottom: 1rem;
    }


</style>